import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EpErrorService, ToastService } from '@isophi/core-ui';
import { KindergartenService } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize, Subscription } from 'rxjs';

@Component({
  selector: 'app-workplace-form',
  templateUrl: './workplace-form.component.html',
  styleUrls: ['./workplace-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkplaceFormComponent implements OnDestroy {
  private readonly epErrorService = inject(EpErrorService);
  workplaceForm: FormGroup;
  private _subs: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private kindergartenService: KindergartenService,
    private spinner: NgxSpinnerService,
    private transloco: TranslocoService,
    private toastr: ToastService
  ) {
    this.workplaceForm = this.fb.group({
      workplaceName: [''],
      izo: [''],
      workplaceSchoolPartNumber: [''],
      workplaceStreetAddress: [''],
      workplaceCity: [''],
      workplaceDistrict: [''],
      workplacePostcode: [''],
    });

    this._subs.push(
      this.kindergartenService.kindergartenDetailRetrieve().subscribe({
        next: (val) => {
          this.workplaceForm.patchValue(val);
        },
      })
    );
  }

  onSubmit(): void {
    if (this.workplaceForm.valid) {
      this.spinner.show();
      this.kindergartenService
        .kindergartenUpdatePartialUpdate(this.workplaceForm.value)
        .pipe(finalize(() => this.spinner.hide()))
        .subscribe({
          next: () => {
            this.toastr.success(this.transloco.translate('settings/basicDataSuccess'), this.transloco.translate('settings/workplace'));
          },
          error: (e) => {
            this.epErrorService.handleEpErrorResponse(e, { defaultMessage: this.transloco.translate('settings/workplace') });
            this.spinner.hide();
          },
        });
    }
  }

  ngOnDestroy(): void {
    this._subs.forEach((s) => s.unsubscribe());
  }
}
